import { TRIAL_DAYS, isTrialRegistration } from './trial';

export const BRANCH_YEAR_PRICE = 1999;
/** @deprecated Use BRANCH_YEAR_PRICE */
export const RENEWAL_PRICE = BRANCH_YEAR_PRICE;
/** @deprecated No introductory ₹100 tier — same price year 1 */
export const FIRST_YEAR_PRICE = BRANCH_YEAR_PRICE;

export const PRICING_FOOTNOTE =
  '7-day free trial on your first branch · Then ₹1,999/year per branch · One counter PC per branch (once only)';

export const CLOUD_COMING_SOON_NOTE =
  'Cloud (multi-branch analytics across all locations) is coming in a later release. Standard includes one branch today — add locations at ₹1,999/year each until Cloud launches.';

/** @deprecated Counter PC connection is free */
export function calcRegistrationTotal() {
  return 0;
}

/** @deprecated Counter PC connection is free */
export function formatRegistrationBreakdown() {
  return { label: 'Connect counter PC', amount: 'Free' };
}

export function calcBranchAddTotal({ selectedYears = 1, onTrial = false }) {
  if (onTrial) return 0;
  return selectedYears * BRANCH_YEAR_PRICE;
}

export function formatBranchAddBreakdown({ selectedYears = 1, isFirstPaidBranch = false, onTrial = false }) {
  if (onTrial) {
    return { label: '7-day trial (first branch)', amount: 'Free' };
  }
  const total = calcBranchAddTotal({ selectedYears, onTrial });
  const label = isFirstPaidBranch
    ? `Main branch · ${selectedYears} year${selectedYears > 1 ? 's' : ''}`
    : `Additional branch · ${selectedYears} year${selectedYears > 1 ? 's' : ''}`;
  return { label, amount: `₹${total.toLocaleString('en-IN')}` };
}

export function getPortalPricingPlans({ restaurant, branches, devices, trialDaysLeft }) {
  const onTrial = isTrialRegistration(restaurant, devices?.length ?? 0);
  const hasActiveSubscription = (branches || []).filter((b) => b.status === 'active').length > 0 && !onTrial;

  return [
    {
      id: 'trial',
      name: '7-day trial',
      price: '₹0',
      period: 'Full access · no card',
      description: 'Keep everything free for 7 days — Main branch and one counter PC included.',
      features: [
        '7 days free on first branch',
        'One counter PC per branch (once only)',
        'Desktop & mobile app download',
        'LAN mobile sync at branch',
        'Then ₹1,999/year per branch',
      ],
      highlight: onTrial,
      badge: onTrial ? `${trialDaysLeft}d left` : null,
      cta: onTrial ? 'Connect counter PC' : 'Trial ended',
      disabled: !onTrial,
    },
    {
      id: 'standard',
      name: 'Standard',
      price: '₹1,999',
      period: 'Per branch · per year',
      description: 'One shop location — branch license covers counter PC + mobile on LAN.',
      features: [
        '₹1,999 every year per branch',
        'One counter PC per branch (once only)',
        'Extra branch: ₹1,999/year each',
        '1 branch included on signup',
        'Cloud activation key per branch',
      ],
      highlight: !onTrial && !hasActiveSubscription,
      badge: !onTrial && !hasActiveSubscription ? 'Your next step' : null,
      cta: 'Manage branches',
      disabled: false,
    },
    {
      id: 'cloud',
      name: 'Cloud',
      price: 'Custom',
      period: 'Multi-branch analytics · coming soon',
      description: 'Roll-up reporting and central dashboard across all your locations.',
      features: [
        'Multi-location analytics (planned)',
        'Central owner portal (planned)',
        'Sync key still per branch',
        'Counter PC + mobile unchanged',
        'Contact us for early access',
      ],
      highlight: false,
      badge: 'Coming soon',
      cta: 'Coming soon',
      disabled: true,
      comingSoon: true,
      contact: false,
    },
  ];
}

export function getTrialProgressPercent(trialDaysLeft) {
  return Math.max(0, Math.min(100, ((TRIAL_DAYS - trialDaysLeft) / TRIAL_DAYS) * 100));
}